<template>
  <img
    src="../assets/other/01.png"
    :style="{
      width: '100%',
      height: '100%',
      position: 'absolute',
      inset: 0,
      zIndex: -1,
    }"
  />
</template>
